import { installDevFakeClock } from './dev-fake-clock.js';

const env = import.meta.env as { VITE_FAKETIME?: string };

installDevFakeClock(env.VITE_FAKETIME);
